import React from 'react'
import { Locale } from 'antd/lib/locale-provider'
import zhTW from 'antd/lib/locale/zh_TW'
import enUS from 'antd/lib/locale/en_US'
import { pathOr } from 'ramda'
import { useQueryWebSetting } from '@/graphql/setting'

export type LocaleContextType = {
  locale: any
  setLocale: React.Dispatch<React.SetStateAction<Locale | null>>
}

export const LocaleContext = React.createContext<LocaleContextType>({
  locale: null,
  setLocale: (value: React.SetStateAction<Locale | null>) => ({}),
})

export const locales = {
  'zh-TW': zhTW,
  en: enUS,
}

export function LocaleProvider(props: any) {
  const { web } = useQueryWebSetting()

  const [locale, setLocale] = React.useState<Locale | null>(
    pathOr(null, [web.language], locales)
  )

  const value = React.useMemo(
    () => ({
      locale,
      setLocale,
    }),
    [JSON.stringify(locale)] // eslint-disable-line
  )

  return <LocaleContext.Provider value={value} {...props} />
}

export function useLocale() {
  const context = React.useContext(LocaleContext)
  if (context === undefined) {
    throw new Error(`useLocale must be used within a LocaleProvider`)
  }
  return context
}

export default useLocale
